/**
 * Material Selector Component
 * Dropdown selector for waste material types
 */


import type { WasteStreamType } from '../../types';
import { formatWasteStreamType } from '../../utils/formatting';

interface MaterialSelectorProps {
  value: WasteStreamType | '';
  onChange: (value: WasteStreamType) => void;
  disabled?: boolean;
  error?: string;
}

const MATERIAL_TYPES: WasteStreamType[] = [
  'wood',
  'metal',
  'concrete',
  'asphalt',
  'drywall',
  'cardboard',
  'plastic',
  'glass',
  'carpet',
  'other',
];

export function MaterialSelector({
  value,
  onChange,
  disabled = false,
  error,
}: MaterialSelectorProps) {
  return (
    <div>
      <label htmlFor="material-type" className="block text-sm font-medium text-neutral-700 mb-1">
        Material Type
      </label>
      <select
        id="material-type"
        value={value}
        onChange={(e) => onChange(e.target.value as WasteStreamType)}
        className="input-field"
        disabled={disabled}
        required
        aria-describedby={error ? 'material-error' : undefined}
      >
        <option value="">Select material type...</option>
        {MATERIAL_TYPES.map((type) => (
          <option key={type} value={type}>
            {formatWasteStreamType(type)}
          </option>
        ))}
      </select>
      {error && (
        <p id="material-error" className="text-sm text-red-600 mt-1" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}